import React, { FC, ReactNode } from 'react';
import { fade, Grid, makeStyles, Theme, Typography } from '@material-ui/core';

export interface SilverDescriptionProps {
  result: string;
  description: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  result: {
    border: `2px solid ${theme.palette.primary.main}`,
    boxSizing: 'border-box',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 25,
    padding: theme.spacing(2, 1.6),
    lineHeight: 1,
    [theme.breakpoints.up(375)]: {
      fontSize: 32,
      padding: theme.spacing(2, 1.8),
    },
    [theme.breakpoints.up('sm')]: {
      marginRight: 10,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 28,
      lineHeight: 1.5,
      padding: theme.spacing(2),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 32,
      lineHeight: '45px',
      padding: theme.spacing(3),
    },
  },
  description: {
    fontWeight: 500,
    lineHeight: '22px',
    marginTop: 13,
    padding: 0,
    fontSize: 14,
    minWidth: 70,
    maxWidth: 90,
    [theme.breakpoints.up(375)]: {
      fontSize: 16,
      minWidth: 80,
      maxWidth: 100,
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: 18,
    },
    [theme.breakpoints.up('md')]: {
      marginTop: 0,
    },
  },
}));
const SilverResults: FC<SilverDescriptionProps> = ({ result, description }) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <Typography variant={'h6'} color={'primary'} className={classes.result}>
        {result}
      </Typography>
      <Typography color={'textPrimary'} className={classes.description}>
        {description}
      </Typography>
    </div>
  );
};

export default SilverResults;
